import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import CarouselLoadingWrapper from '@/components/CarouselLoadingWrapper/CarouselLoadingWrapper';
import { FeaturedAuctioneer } from '@/redux/modules/home/home.types';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { AuctioneerCard } from './AuctioneerCard';

type FeaturedAuctioneersCarouselProps = {
    featuredAuctioneers: FeaturedAuctioneer[];
};

export const FeaturedAuctioneersCarousel = ({ featuredAuctioneers }: FeaturedAuctioneersCarouselProps) => {
    const formatMessage = useAppFormatMessage();
    const {
        breakpoints: { pageWidthNum },
    } = useTheme();

    const carouselCards = useMemo(
        () =>
            featuredAuctioneers.map(({ destinationURL, featuredAuctioneerId, houseId, houseName, imageURL }) => ({
                card: (
                    <AuctioneerCard
                        destinationURL={destinationURL}
                        featuredAuctioneerId={featuredAuctioneerId}
                        houseId={houseId}
                        houseName={houseName}
                        imageURL={imageURL}
                        key={`${featuredAuctioneerId}-${houseId}`}
                    />
                ),
                key: `${featuredAuctioneerId}-${houseId}`,
            })),
        [featuredAuctioneers]
    );

    return (
        <CarouselLoadingWrapper className={`mx-auto w-[calc(100%-40px)] max-w-[${pageWidthNum - 40}px]`}>
            <Carousel
                cards={carouselCards}
                title={String(formatMessage(['featuredAuctioneers', 'featured']))}
            />
        </CarouselLoadingWrapper>
    );
};
